var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.agreementShow)?_c('div',{staticClass:"template_pop"},[_c('div',[_c('div',{staticClass:"template_pop_title"},[_vm._v("运营猫商机领航用户协议")]),_c('div',{staticClass:"rule_content",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.close}},[_vm._v("确认协议")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }